export const MAX_ENTRIES = 3;
export const PARAM_NAME = 'carlines';
const isAbsolute = (url) => /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(url);
const getRelativePath = (original, url) => {
    if (!original.startsWith('/') && url.pathname.startsWith('/')) {
        return url.pathname.slice(1);
    }
    return url.pathname;
};
export const generateCompareUrl = (url, carlines) => {
    if (carlines.length === 0) {
        return url;
    }
    const urlObj = new URL(url, 'https://www.audi.de');
    urlObj.searchParams.set(PARAM_NAME, carlines.slice(0, MAX_ENTRIES).join(','));
    if (isAbsolute(url)) {
        return urlObj.toString();
    }
    return getRelativePath(url, urlObj) + urlObj.search + urlObj.hash;
};
export const getCompareCarlines = (location) => {
    const searchParams = new URLSearchParams(location.search);
    const compare = searchParams.get(PARAM_NAME);
    return (compare?.split(',').reduce((arr, carline, index) => {
        if (index < MAX_ENTRIES && carline.length > 0) {
            return [...arr, carline];
        }
        return arr;
    }, new Array()) ?? []);
};
//# sourceMappingURL=index.js.map